import { render, staticRenderFns } from "./DeleteResponseCode.vue?vue&type=template&id=98c6c920&"
import script from "./DeleteResponseCode.vue?vue&type=script&lang=js&"
export * from "./DeleteResponseCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports